<div class="flex flex-wrap items-center gap-1">
    <label>{{ 'common.from' | translate }}:</label>
    <p-datepicker
        styleClass="ml-1"
        [(ngModel)]="fromDate"
        (onSelect)="dateChanged()"
        (onBlur)="dateChanged()"
        (keydown.enter)="dateChanged()"
        [showWeek]="true"
        [maxDate]="endDate"
    ></p-datepicker>
    <label class="ml-2">{{ 'common.to' | translate }}:</label>
    <p-datepicker
        styleClass="ml-1"
        [(ngModel)]="endDate"
        (onSelect)="dateChanged()"
        (onBlur)="dateChanged()"
        (keydown.enter)="dateChanged()"
        [showWeek]="true"
        [minDate]="fromDate"
    ></p-datepicker>
    <!-- checkbox to show delivery of goods -->
    <phx-checkbox
        styleClass="ml-2"
        [(ngModel)]="showEstimatedInboundQuantity"
        (ngModelChange)="refreshDeliveryOfGoods()"
        [label]="'warehouse.show-estimated-delivery-of-goods' | translate"
    ></phx-checkbox>
</div>

<p-card class="flex items-center mt-2 w-full" styleClass="w-full">
    @if (isLoadingSig() == false) {
        @defer (on immediate) {
            <phx-chart height="350pt" type="line" [data]="data" [options]="options" />
        } @placeholder {
            <div class="w-full flex justify-center">
                <p-progressSpinner styleClass="mt-8 mb-8"></p-progressSpinner>
            </div>
        }
    } @else {
        <div class="w-full flex justify-center">
            <p-progressSpinner styleClass="mt-8 mb-8"></p-progressSpinner>
        </div>
    }
</p-card>
